import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'widower.dating',
  TITLE: 'Widower Dating',
  NICHE: 'widow',
  PROJECT: 'widowerdating',
  NICHE_SINGULAR: 'widow',
  NICHE_PLURAL: 'widows',
  FB_TRACKING_PIXEL_ID: ['294051721505088', '396166061372795'],
  BING_TRACKING_PIXEL: ['343093832'],
  VERIZON_TRACKING_PIXEL: '10111278',
  TABOOLA_TRACKING_PIXEL: '1800925',
  TYPE: 'mainstream',
  SENTRY_RELEASE: 'www-widower-dating',
  SENTRY_DNS: 'https://7264de0302a56e2108547cd01b0fab49@sentry.nearbyapi.com/8',
  VWO_ID: 302021,
});

export default config;



// WEBPACK FOOTER //
// ./src/constants/config.js